import React from 'react';
import { Hero } from '../components/Hero';
import { BrandSection } from '../components/BrandSection';
import { ServiceBanner } from '../components/ServiceBanner';
import { AboutSection } from '../components/AboutSection';
export function Home() {
  return <>
      <Hero data-id="element-238" data-mp="2s8z4yt27fcpr" />
      <BrandSection data-id="element-239" data-mp="2x5pr9y4lr4jm" />
      <section className="w-full bg-slate-50 pb-16" data-id="element-240" data-mp="2x5z92yfhu5e8">
        <div className="mx-auto w-full max-w-[1360px] px-5 lg:px-10" data-id="element-241" data-mp="2x7sfqdq3wpm8">
          <ServiceBanner className="min-h-[300px]" data-id="element-242" data-mp="1zj8vwyffj10i" />
        </div>
      </section>
      <AboutSection data-id="element-243" data-mp="24i3fi2l80tlo" />
    </>;
}